import { render, staticRenderFns } from "./FormattingRuleSetup.vue?vue&type=template&id=4921a4d4&scoped=true&"
import script from "./FormattingRuleSetup.vue?vue&type=script&lang=ts&"
export * from "./FormattingRuleSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4921a4d4",
  null
  
)

export default component.exports